import React from 'react'

export function FileImg (props) {
  const { pictureKey, SessionToken, ...rest } = props
  return <img {...rest} src={`${process.env.API_URL || ''}/Files/Get/${pictureKey}/?token=${SessionToken}`} />
}

export function FileImgBuildPath (fileKey, SessionToken) {
  return `${process.env.API_URL || ''}/Files/Get/${fileKey}/?token=${SessionToken}`
}
